var map = {
	"./light/sport/04sportDesc/23hxpl.svg": "jTWD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hhrh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/sport\/04sportDesc\/23hxpl\.svg$
// module id = Hhrh
// module chunks = 0